import { FC } from 'react';
import i18n from 'i18n';
import styles from './BulkEdit.module.scss';
import { hasFuncs } from 'core/permission/PermissionDSL';
import { Permission } from 'core/auth/Permission';
import { ListEditBar } from 'components/ListEditBar/ListEditBar';
import PermissionChecker from 'containers/PermissionChecker/PermissionChecker';
import { ConfirmationWrapper } from 'components/ConfirmationWrapper/ConfirmationWrapper';
interface BulkEditType {
  selectedItems: any[];
  onRemoveSelect: () => void;
  onActivate: () => void;
  onDeactivate: () => void;
  onApprove: () => void;
  onReject: () => void;
}

const ItemWithConfirmation = ({
  title = '',
  description = '',
  onAction = () => {},
}) => {
  return (
    <ConfirmationWrapper description={description} onAction={onAction}>
      {(showModal) => (
        <ListEditBar.Dropdown.Item onClick={showModal}>
          {title}
        </ListEditBar.Dropdown.Item>
      )}
    </ConfirmationWrapper>
  );
};

const BulkActivation = ({ onActivate, onDeactivate }) => {
  return (
    <ListEditBar.Dropdown
      id='bulkActivation'
      className={styles['bulk-activation']}
      title={i18n.t<string>('orderList.labels.bulkActivation')}
    >
      <ItemWithConfirmation
        title={i18n.t<string>('orderList.labels.activate')}
        description={i18n.t<string>(
          'orderList.labels.makeSureAllCampaignsActivated',
        )}
        onAction={onActivate}
      />
      <ItemWithConfirmation
        title={i18n.t<string>('orderList.labels.deactivate')}
        description={i18n.t<string>(
          'orderList.labels.makeSureAllCampaignsDeactivated',
        )}
        onAction={onDeactivate}
      />
    </ListEditBar.Dropdown>
  );
};

const BulkApproval = ({ onApprove, onReject }) => {
  return (
    <ListEditBar.Dropdown
      id='bulkApproval'
      className={styles['bulk-approval']}
      title={i18n.t<string>('orderList.labels.bulkApproval')}
    >
      <ListEditBar.Dropdown.Item onClick={onApprove}>
        {i18n.t<string>('orderList.labels.approve')}
      </ListEditBar.Dropdown.Item>
      <ListEditBar.Dropdown.Item onClick={onReject}>
        {i18n.t<string>('orderList.labels.reject')}
      </ListEditBar.Dropdown.Item>
    </ListEditBar.Dropdown>
  );
};

const BulkEdit: FC<BulkEditType> = ({
  selectedItems,
  onRemoveSelect,
  onActivate,
  onDeactivate,
  onApprove,
  onReject,
}) => {
  return (
    <ListEditBar
      selectedItems={selectedItems}
      handleRemoveSelect={onRemoveSelect}
    >
      <PermissionChecker permissionAware={hasFuncs(Permission.ORDER_APPROVE)}>
        <BulkApproval onApprove={onApprove} onReject={onReject} />
      </PermissionChecker>
      <PermissionChecker
        permissionAware={hasFuncs(Permission.ORDER_WRITE).and(
          hasFuncs(Permission.CAMPAIGN_WRITE),
        )}
      >
        <BulkActivation onActivate={onActivate} onDeactivate={onDeactivate} />
      </PermissionChecker>
    </ListEditBar>
  );
};

export default BulkEdit;
